export default __webpack_public_path__ + "static/media/card_ouvidoria_brasil.2fc798f5.png";